import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusUserAssigned.tsx
const IconApplicationStatusUserAssigned = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M9.167 11.718v4.949h1.667v-4.949a6.67 6.67 0 0 1 5.833 6.616H3.334c0-3.4 2.545-6.205 5.833-6.616m.834-.884c-2.763 0-5-2.238-5-5s2.237-5 5-5 5 2.237 5 5-2.238 5-5 5"
	})]
});
var IconApplicationStatusUserAssigned_default = forwardRef(IconApplicationStatusUserAssigned);
//#endregion
export { IconApplicationStatusUserAssigned_default as default };
